import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: JSON.parse(localStorage.getItem("cartItems")) || [], // Load items from localStorage
  totalAmount: parseFloat(localStorage.getItem("totalAmount")) || 0, // Load totalAmount from localStorage
  totalQuantity: 0,
  isPaymentStep: false, // Track if user is in payment step
};

// Update cart slice to persist totalAmount
const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItem: (state, action) => {
      const newItem = action.payload;
      const exists = state.items.find((item) => item.id === newItem.id);

      if (!exists) {
        state.items.push({
          ...newItem,
          quantity: 1,
        });
        state.totalQuantity = state.items.length;
        state.totalAmount += parseFloat(newItem.price); // Add price incrementally
      }

      // Persist the updated cart and totalAmount to localStorage
      localStorage.setItem("cartItems", JSON.stringify(state.items));
      localStorage.setItem("totalAmount", state.totalAmount.toString());
    },

    incrementQuantity: (state, action) => {
      const id = action.payload;
      const item = state.items.find((item) => item.id === id);

      if (item) {
        item.quantity += 1;
        state.totalAmount += parseFloat(item.price);
      }

      // Persist the updated cart and totalAmount to localStorage
      localStorage.setItem("cartItems", JSON.stringify(state.items));
      localStorage.setItem("totalAmount", state.totalAmount.toString());
    },

    decrementQuantity: (state, action) => {
      const id = action.payload;
      const item = state.items.find((item) => item.id === id);

      if (item && item.quantity > 1) {
        item.quantity -= 1;
        state.totalAmount -= parseFloat(item.price);

        // Persist the updated cart and totalAmount to localStorage
        localStorage.setItem("cartItems", JSON.stringify(state.items));
        localStorage.setItem("totalAmount", state.totalAmount.toString());
      }
    },

    removeItem: (state, action) => {
      const id = action.payload;
      const removedItem = state.items.find((item) => item.id === id);

      if (removedItem) {
        state.items = state.items.filter((item) => item.id !== id);
        state.totalQuantity = state.items.length;
        state.totalAmount -= parseFloat(removedItem.price) * removedItem.quantity;
      }

      // Persist the updated cart and totalAmount to localStorage
      localStorage.setItem("cartItems", JSON.stringify(state.items));
      localStorage.setItem("totalAmount", state.totalAmount.toString());
    },

    clearCart: (state) => {
      state.items = [];
      state.totalQuantity = 0;
      state.totalAmount = 0;
      state.isPaymentStep = false;

      // Clear the cart from localStorage
      localStorage.removeItem("cartItems");
      localStorage.removeItem("totalAmount");
    },

    setPaymentStep: (state, action) => {
      state.isPaymentStep = action.payload;
    },
  },
});

export const { addItem, removeItem, clearCart, incrementQuantity, decrementQuantity, setPaymentStep } = cartSlice.actions;
export default cartSlice.reducer;
